<script setup>
import {ref, watch} from 'vue';

// Define the props
const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  options: {
    type: Array,
    default: () => [],
  }
});

// Define the emits
const emit = defineEmits(['update:modelValue']);

// Local state to bind the v-model
const selectedValue = ref(props.modelValue);

// Watch for changes and emit them
watch(selectedValue, (newValue) => {
  emit('update:modelValue', newValue);
});

watch(() => props.modelValue, (newValue) => {
  selectedValue.value = newValue;
});
</script>


<template>
  <select
      class="tools-base-select"
      v-model="selectedValue">
    <option
        v-for="item in options"
        :key="item.value"
        :value="item.value">
      {{ item.label }}
    </option>
  </select>
</template>

<style scoped>
.tools-base-select {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.tools-base-select:focus {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
</style>
